import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ModelsForManufacturer'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ModelsForManufacturerStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ModelsForManufacturerStore",
			variables: true,
		})
	}
}

export async function load_ModelsForManufacturer(params) {
  await initClient()

	const store = new ModelsForManufacturerStore()

	await store.fetch(params)

	return {
		ModelsForManufacturer: store,
	}
}
